import * as CONSTANTS from "../../utilities/Constants";
import { ICalculatedData as ICalculatedProperty } from "./SampleCalculatedData";
import { IMeasured } from "./SampleMeasuredData";
import { IKeyedInProperty } from "./SampleKeyedInData";
import { IStatus } from "../measurement/InstrumentDetails";
import moment from "moment";

export interface ISourceData {
    id: string;
    name: string;
}

export interface IGradeData {
    id: string;
    name: string;
}

export interface IProductData {
    id: string;
    name: string;
    grade: IGradeData;
}

export interface ITestplanData {
    id: string;
    name: string;
    isPDC: boolean;
}

export interface ISampleViewData {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    sampleDate: string;
    setId: string;
    orderId: string;
    state: string;
    source: ISourceData | null;
    product: IProductData | null;
    grade: IGradeData | null;
    testPlan: ITestplanData | null;
    measured: IMeasured[];
    keyedIns: IKeyedInProperty[];
    calculated: ICalculatedProperty[];
    status: IStatus;
    measurement: string;
    formatedDate:any;
    updatedOn?: any;
}

export default class SampleViewData implements ISampleViewData {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    sampleDate: string;
    setId: string;
    orderId: string;
    state: string;
    source: ISourceData;
    product: IProductData;
    grade:IGradeData;
    testPlan: ITestplanData;
    measured: IMeasured[];
    keyedIns: IKeyedInProperty[];
    calculated: ICalculatedProperty[];
    status: IStatus;
    measurement: string
    formatedDate:any;
    updatedOn?: any;

    constructor(
        id: string,
        name: string,
        description: string,
        isEnabled: boolean,
        sampleDate: string | null,
        setId: string,
        orderId: string,
        source: ISourceData,
        product: IProductData,
        grade:IGradeData,
        testPlan: ITestplanData,
        measured: IMeasured[],
        keyedIns: IKeyedInProperty[],
        calculated: ICalculatedProperty[],
        status: IStatus,
        measurement: string, 
        updatedOn?: any
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.isEnabled = isEnabled;
        this.state = isEnabled ? CONSTANTS.ENABLED : CONSTANTS.DISABLED;
        this.sampleDate =  sampleDate;
        this.setId = setId;
        this.orderId = orderId;
        this.product = product;
        this.grade = grade;
        this.source = source;
        this.testPlan= testPlan;
        this.keyedIns = keyedIns;
        this.measured = measured;
        this.calculated = calculated;
        if (status === undefined || status === null) {
            this.status = {
                id: "NotMeasured",
                name: "NotMeasured"
            };
        }
        else {
            this.status = status;
        }
        this.measurement = measurement;

        let dateObject;
        let dateFormat;
        let timeFormat = "";
        if (localStorage.getItem('dateObject') && JSON.parse(localStorage.getItem('dateObject')).dateFormat) {
          dateObject = localStorage.getItem('dateObject');
          dateFormat = JSON.parse(dateObject).dateFormat?.toUpperCase();
          if (JSON.parse(dateObject).timeFormat.includes("tt") || JSON.parse(dateObject).timeFormat.includes("A")) {
            timeFormat = "hh:mm A"
          } else {
            timeFormat = "HH:mm"
          }
        } else {
          dateObject = '{"cultureCode":"en-IN","dateFormat":"YYYY-MM-DD","timeFormat":"HH:mm","fullTimeFormat":"YYYY-MM-DD HH:mm","timeOffset":330}';
          dateFormat = "YYYY-MM-DD";
          timeFormat = "HH:mm";
        }
        let dateFormatting = `${dateFormat} ${timeFormat}`;
        let offset = JSON.parse(dateObject).timeOffset;
        
        this.formatedDate = sampleDate ? moment.utc(sampleDate).utcOffset(offset || 0).format(dateFormatting) : null;
        this.updatedOn = updatedOn ? moment.utc(updatedOn).utcOffset(offset || 0).format(dateFormatting) : null;
        this.sampleDate = sampleDate ? moment.utc(sampleDate).utcOffset(offset || 0).format() : sampleDate;
    }
}

const defaultSampleData = new SampleViewData(
    "",
    "",
    "",
    true,
    "",
    "",
    "",
    { id: "", name: "" },
    { id: "", name: "", grade: { id: "", name: "" } },
    { id: "", name: "" },
    { id: "", name: "",isPDC:false },
    [],
    [],
    [],
    { id: "", name: "" },
    "",
    ""
);
export { defaultSampleData };
